import { PropsWithChildren } from 'react';

import css from './styles.module.css';

export type TimelineTitleProps = PropsWithChildren;

/** The event's headline. */
export function TimelineTitle({ children }: TimelineTitleProps) {
  return <p className={css.title}>{children}</p>;
}
